export default "__VITE_ASSET__BVaUMYH7__"